export default __webpack_public_path__ + "static/media/tractor_lock_hover.c49a0ecd.svg";